import { request } from "services/api/util";

class DayOffService {
  async _fetchDayOffList(endpoint, storeCode, resourceId, params) {
    const config = {
      method: "get",
      url: `admin/store/${storeCode}/${endpoint}/${resourceId}/dayOffs`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getRoomDayOffs(storeCode, id, params) {
    return this._fetchDayOffList("rooms", storeCode, id, params);
  }

  async getStaffDayOffs(storeCode, id, params) {
    return this._fetchDayOffList("staffs", storeCode, id, params);
  }

  async _createDayOff(endpoint, storeCode, resourceId, body) {
    const config = {
      method: "post",
      url: `admin/store/${storeCode}/${endpoint}/${resourceId}/dayOffs`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async createRoomDayOff(storeCode, id, body) {
    return this._createDayOff("rooms", storeCode, id, body);
  }

  async createStaffDayOff(storeCode, id, body) {
    return this._createDayOff("staffs", storeCode, id, body);
  }

  async _deleteDayOff(endpoint, storeCode, resourceId, id) {
    const config = {
      method: "delete",
      url: `admin/store/${storeCode}/${endpoint}/${resourceId}/dayOffs/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async deleteRoomDayOff(storeCode, resourceId, id) {
    return this._deleteDayOff("rooms", storeCode, resourceId, id);
  }

  async deleteStaffDayOff(storeCode, resourceId, id) {
    return this._deleteDayOff("staffs", storeCode, resourceId, id);
  }
}

export default new DayOffService();
